module.exports = __webpack_public_path__ + "static/media/nect-logo-white.2d4d4408.svg";